import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import styled from 'styled-components';

export const Container = styled.div``;

export const Color = styled.span<{ $color?: string }>`
  display: block;
  height: 1em;
  width: 0.3rem;

  border-radius: ${({ theme }) => theme.spacing(0.5)};
  background: ${({ $color, theme }) =>
    schemeColor($color, theme) ?? 'transparent'};
`;
